/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sour_Fuzzy_Martin_AnimateInputs */

const fr_sour_fuzzy_martin_animate = /** @type {(inputs: Sour_Fuzzy_Martin_AnimateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

/**

* @param {Sour_Fuzzy_Martin_AnimateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sour_fuzzy_martin_animate = /** @type {((inputs?: Sour_Fuzzy_Martin_AnimateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sour_Fuzzy_Martin_AnimateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sour_fuzzy_martin_animate(inputs)
});